export const redirect = redirectUrl => {
  window.location.href = redirectUrl;
};